import { Text, FlexContainer, Icon, Accordion } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import * as Styled from './styles';
import { WarningListProps } from './type';

const TabHeader = ({ text }): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  return (
    <Styled.TabHeader gap="dimension_08" hasWarnings>
      <Icon color="warning" icon="IconWarningAttentionSolidS" />
      <Text type="paragraphs" color="warning_strong" size="S_L_S">
        {t(text)}
      </Text>
    </Styled.TabHeader>
  );
};

const WarningsList = ({ warning }: WarningListProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  return (
    <Accordion>
      <TabHeader text="Result.warning.title" />
      <FlexContainer direction="column" gap="dimension_16">
        <Text type="paragraphs" size="XS_S_S" color="grey">
          {t('Result.warnings.subtitle')}
        </Text>
        <Styled.WarningItem>
          {warning.map(item => (
            <FlexContainer key={item.id} gap="dimension_08">
              <Icon color="warning" icon="IconWarningAttentionSolidS" />
              <Text type="paragraphs" size="S_M_S" color="dark">
                {item.message}
              </Text>
            </FlexContainer>
          ))}
        </Styled.WarningItem>
      </FlexContainer>
    </Accordion>
  );
};

export default WarningsList;
